// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProductPrice p{font-size:14px;font-weight:bolder}.ProductPrice ins{font-weight:600;text-decoration:none}.ProductPrice .SpecialPrice span{color:var(--color-brand)}.ProductPrice del{font-weight:300;color:#747081;margin-left:20px}@media (max-width: 767px){.ProductPrice del{margin-left:10px}}.ProductPrice-HighPrice_isVisible{display:inline-block}\n", ""]);
// Exports
module.exports = exports;
